import { useRequestWithClientId } from './client/useRequest';
import { graphql } from '../graphql';
const GET_SDK_STATUS = graphql(`
  query GetSdkStatus($lob: String!) {
    getSdkStatus(input: { lineOfBusiness: $lob }) {
      ok
    }
  }
`);
export const useGetSdkStatusRequest = (lineOfBusiness, clientId) => {
    return useRequestWithClientId(false, lineOfBusiness, clientId, GET_SDK_STATUS, { lob: lineOfBusiness });
};
